
<mat-toolbar class="min-h-[40px] max-h-[40px]">
  <span class="text-xs pr-4">Oregon Health Authority</span>
  <span class="text-xs pr-4">Public Health Lab</span>
  <span class="text-xs pr-4">Oregon Environmental Laboratory Accreditation Program</span>
  <span class="text-xs">{{environment.build}} Version {{environment.version}}</span>
</mat-toolbar>
